
import { mapGetters } from "vuex";
import ResultProductCard from "~/components/common/ResultProductCard";
import { addCurrentTranslation } from "~/utils/index.js";
import UiSwiperCarousel from "~/components/UI/UiSwiperCarousel.vue";

export default {
  name: "RecentlyViewedBlock",
  components: {
    UiSwiperCarousel,
    ResultProductCard,
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapGetters({
      getCurrentLangId: "general/getCurrentLangId",
      getDefaultLangId: "general/getDefaultLangId",
    }),
    mapedData() {
      return this.items.map((el) => ({
        ...el,
        image: el?.images?.[0]?.url,
      }));
    },
  },
  mounted() {
    const items = this.getRecentlyViewed();
    if (items && items.length) {
      this.items = addCurrentTranslation(
        items,
        this.getCurrentLangId(this.$i18n.locale),
        this.getDefaultLangId
      );
    }
  },
  methods: {
    getRecentlyViewed() {
      const localStorageItems = JSON.parse(
        localStorage.getItem("recentlyViewed")
      );
      return (
        localStorageItems?.filter((el) => el.lang === this.$i18n.locale) || []
      );
    },
    scrollTop(product) {
      if(this.$route.path.includes("/product") && this.$route.params.slug === product.slug) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
